// Add this import at the top of your file
import BrandedQRCode from './BrandedQRCode';
import { useState } from 'react';

// Add this component inside your CreateRoom component, after the share link section
export const QRCodePopup = ({ roomUrl, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-lg max-w-sm w-full">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-gray-800">Scan to Join</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          
          <div className="flex justify-center p-4 bg-gray-50 rounded-lg">
            <BrandedQRCode value={roomUrl} size={200} />
          </div>
          
          <div className="mt-4 text-center">
            <p className="text-gray-600 mb-4">
              Scan this QR code with your phone's camera to join the game
            </p>
            <button
              onClick={onClose}
              className="bg-red-600 text-white font-semibold px-6 py-2 rounded-lg hover:bg-red-700 transition duration-300"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};